import { Alert, Button, Icon, IconName } from '@unmind/design-system';
import React, { RefObject, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import Modal from 'Shared/Modal';
import { useCancelAppointment } from 'Book/shared/hooks';

import { ModalContent } from './styles';

export type IDetailsProps = {
  appointmentId: string;
  date: string;
  counsellor: string;
};
export type ModalProps = {
  details: IDetailsProps;
  functions: {
    onCancel?(): void;
    onClose(): void;
  };
  isOpen: boolean;
  parentRef: RefObject<HTMLElement>;
  testId?: string;
};

const CancelEAPAppointmentModal = ({
  details,
  functions,
  isOpen,
  parentRef,
  testId = 'cancel-modal',
}: ModalProps) => {
  const [cancelAppointment] = useCancelAppointment();
  const { t } = useTranslation('book', {
    keyPrefix: 'service.cancelModal',
  });
  const theme = useTheme();
  const [isCancelling, setIsCancelling] = useState<boolean | 'error'>(false);

  return (
    <Modal
      testId={testId}
      open={isOpen}
      onCloseCallback={functions.onClose}
      closeHeader
      modalContent={({ close }) => (
        <ModalContent>
          {isCancelling === 'error' && (
            <Alert
              className="alert"
              title={t('error')}
              variant="error"
              size="small"
            />
          )}

          <h2>{t('title')}</h2>
          <Trans
            t={t}
            i18nKey="text"
            components={{
              p: <p />,
            }}
            values={details}
          />
          <ul className="ctas">
            <li>
              <Button
                label={t('ctas.keep')}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  close();
                  functions.onClose();
                }}
                disabled={isCancelling === true}
              />
            </li>
            <li>
              <Button
                variant="primary"
                label={
                  isCancelling === true ? (
                    <Icon
                      iconName={IconName.Spinner}
                      colors={{
                        primary: theme.button.primary.default.textColor,
                      }}
                    />
                  ) : (
                    t('ctas.cancel.short')
                  )
                }
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsCancelling(true);

                  cancelAppointment({
                    variables: { id: details.appointmentId },
                  })
                    .then(() => {
                      close();
                      functions.onClose();

                      if (functions.onCancel) {
                        functions.onCancel();
                      }
                    })
                    .catch(() => {
                      setIsCancelling('error');
                    });
                }}
                disabled={isCancelling === true}
              />
            </li>
          </ul>
        </ModalContent>
      )}
      size="medium"
      returnFocusTo={parentRef}
    />
  );
};

export default CancelEAPAppointmentModal;
